export default __webpack_public_path__ + "static/user2-ec46cc1171d7f061d9f2f7eb82751296.webp";